export const paymentTypes = [
    {id: 1,payment_type:"none"},
    {id: 2,payment_type:"cash"},
    {id: 3,payment_type:"credit"},
]

export const accountTypes = [
    {id: 1,payment_type:"none"},
    {id: 2,payment_type:"cash"},
    {id: 3,payment_type:"credit"},
]

export const destinationTypes = [
    {id: 1,destination_type:"stores"},
    {id: 2,destination_type:"expense"},
]

export const purchaseTypes = [
    {id: 1,purchase_type:"cash"},
    {id: 2,purchase_type:"credit"},
]

export const currencyTypes = [
    { id: 1,currency_type: "KES"},
    { id: 2,currency_type: "USD"},
]

export const userTypes = [
    { id: 2,userType: "admin", value:"true"},
    { id: 2,userType: "user", value:"false"},
]



export const unitTypes = [
    { id: 1,unit_type: "M"},
    { id: 2,unit_type: "cm"},
    { id: 3,unit_type: "feet"},
    { id: 4,unit_type: "g"},
    { id: 5,unit_type: "kg"},
    { id: 6,unit_type: "mg"},
    { id: 7,unit_type: "L"},
    { id: 8,unit_type: "ml"},
    { id: 9,unit_type: "inch"},
    { id: 10,unit_type: "feet"},
    { id: 11,unit_type: "tonnes"},
    { id: 12,unit_type: "m3"},
    { id: 13,unit_type: "m2"},
    { id: 14,unit_type: "cm2"},

]